import BookLayout from "features/books/layouts/BookLayout/BookLayout";
import Container from "hardcover-ui/components/Container";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import { BookListsPageProps } from "./index.props";
import { usePage } from "@inertiajs/react";
import Pagination from "components/shared/Pagination";
import BookListGroup from "components/BookGroup/groups/BookListGroup";

function ListsIndex() {
  const { lists } = usePage<BookListsPageProps>().props;

  return (
    <BookLayout>
      <Container variant="layout" size="md">
        {lists.map((list) => (
          <BookListGroup
            key={`book-list-${list.id}`}
            list={list}
            size="md"
            className="py-6 lg:py-8 border-b border-gray-200 dark:border-gray-700"
          />
        ))}
        <Pagination />
      </Container>
    </BookLayout>
  );
}

ListsIndex.layout = DefaultLayoutWrapper;
export default ListsIndex;